// ============================================================================
// SEGMENT TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'segment-tree',
  name: 'Segment Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(4N)'
  },
  description: 'A binary tree data structure for storing information about intervals or segments. Enables efficient range queries and point updates in O(log N) time, commonly used for range minimum/maximum/sum queries.'
};
